/*路由配置*/
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import UserLogin from "@/views/public/userLogin";
import AuthorizedLogin from "@/views/public/authorizedLogin"
import CodeLogin from "@/views/public/codeLogin"
import ResetPwd from "@/views/public/resetPwd"
import Register from "@/views/public/register"
import GroupHome from "@/views/groupHome"
import Policy from "@/views/public/policy"
import WorkBook from "@/views/public/workBook"
import InviteMember from "@/views/public/inviteMember"
import expertJoin from "@/views/public/expertJoin"
import newsShare from "@/views/public/newsShare"

import ArrayMaintenance from "@/views/arrayMaintenance/copytext"

import GroupSet from "@/views/groupSet/index"

import GroupSetAdd from "@/views/groupSet/groupSetAdd"

import editor from "@/views/editor"

import news from "@/views/news/index"
import newsAdd from "@/views/news/newsAdd"
import newsDetail from "@/views/news/newsDetail"

import classLibrary from "@/views/classLibrary/index"
import classLibraryAdd from "@/views/classLibrary/classLibraryAdd"
import classLibraryDetail from "@/views/classLibrary/classLibraryDetail"

import banner from "@/views/banner/index"
import bannerAdd from "@/views/banner/bannerAdd"
import bannerDetail from "@/views/banner/bannerDetail"

import bannerNotice from "@/views/bannerNotice/index"
import bannerNoticeAdd from "@/views/bannerNotice/bannerNoticeAdd"
import bannerNoticeDetail from "@/views/bannerNotice/bannerNoticeDetail"

import lesson from "@/views/lesson/index"
import lessonAdd from "@/views/lesson/lessonAdd"
import lessonDetail from "@/views/lesson/lessonDetail"
import lessonOwnerDetail from "@/views/lesson/lessonOwnerDetail.vue";
import lessonShare from "@/views/lesson/lessonShare"
import lessonFileDetail from "@/views/lesson/lessonFileDetail"
import lessonFileGADetail from "@/views/lesson/lessonFileGADetail"
import lessonDiscuss from "@/views/lesson/lessonDiscuss"
import viewLessonDiscuss from "@/views/lesson/viewLessonDiscuss.vue";
import myLess from "@/views/lesson/myLess"
import shareApply from "@/views/lesson/shareApply"

import evaluation from "@/views/evaluation/index"
import evaluationAdd from "@/views/evaluation/evaluationAdd"
import evaluationDetail from "@/views/evaluation/evaluationDetail"

import rateScale from "@/views/rateScale/index"

import train from "@/views/train/index"
import trainAdd from "@/views/train/trainAdd"
import trainDetail from "@/views/train/trainDetail"
import trainCourseLookVideo from "@/views/train/trainCourseLookVideo"

import videoLibrary from "@/views/train/videoLibrary"
import videoLibraryAdd from "@/views/train/videoLibraryAdd"

import lead from "@/views/lead/index"
import leadAdd from "@/views/lead/leadAdd"
import leadDetail from "@/views/lead/leadDetail"
import topicApply from "@/views/topicApply/index"
import topicApplyDetail from "@/views/topicApply/topicApplyDetail"
import activitApplyDetail from "@/views/topicApply/activitApplyDetail"
/*主（子）课题*/
import topic from "@/views/topic/index"
import topicAdd from "@/views/topic/topicAdd"
import topicManager from "@/views/topic/topicManager"
import subTopicManager from "@/views/topic/subTopicManager"
import topicCheck from "@/views/topic/topicCheck"
import topicBmCheck from "@/views/topic/bmTopicCheck"
import topicKtCheck from "@/views/topic/ktTopicCheck"
import topicZqCheck from "@/views/topic/zqTopicCheck"
import topicJtCheck from "@/views/topic/jtTopicCheck"
import topicRelease from "@/views/topic/topicRelease.vue"


import race from "@/views/race/index"
import raceAdd from "@/views/race/raceAdd"
import raceCreate from "@/views/race/raceCreate"
import raceDetail from "@/views/race/raceDetail"
import raceManager from "@/views/race/raceManager"
import raceSignInfo from "@/views/race/raceSignInfo"
import csRaceSignInfo from "@/views/race/csRaceSignInfo"
import fsRaceSignInfo from "@/views/race/fsRaceSignInfo"
import zsRaceSignInfo from "@/views/race/zsRaceSignInfo"
import raceScale from "@/views/race/raceScale";

import activity from "@/views/activity/index"
import activityAdd from "@/views/activity/activityAdd"
import activityCreate from "@/views/activity/activityCreate"
import activityDetail from "@/views/activity/activityDetail"
import activityScale from "@/views/activity/activityScale";
import activityManager from "@/views/activity/activityManager";
import bmActivitySignInfo from "@/views/activity/bmActivitySignInfo";
import csActivitySignInfo from "@/views/activity/csActivitySignInfo";
import fsActivitySignInfo from "@/views/activity/fsActivitySignInfo";
import zsActivitySignInfo from "@/views/activity/zsActivitySignInfo";

import handleApply from "@/views/handleApply/index"
import handleApplyDetail from "@/views/handleApply/handleApplyDetail"

import famousCourse from "@/views/famousCourse/index"
import famousCourseAdd from "@/views/famousCourse/famousCourseAdd"
import famousCourseDetail from "@/views/famousCourse/famousCourseDetail"
import famousCourseUploadVideo from "@/views/famousCourse/famousCourseUploadVideo"
import famousCourseHumanityVideo from "@/views/famousCourse/famousCourseHumanityVideo"
import famousCourseHumanityLookVideo from "@/views/famousCourse/famousCourseHumanityLookVideo.vue";
import famousList from "@/views/famousCourse/famousList"
import famousCourseLookVideo from "@/views/famousCourse/famousCourseLookVideo"

import studioCourseManager from "@/views/famousPrincipal/studioCourseManager.vue";
import studioCourseCreate from "@/views/famousPrincipal/studioCourseCreate.vue";
import studioCourseInfo from "@/views/famousPrincipal/studioCourseInfo.vue";
import studioViewCourse from "@/views/famousPrincipal/studioViewCourse.vue";

import courseware from "@/views/courseware/index"
import coursewareAdd from "@/views/courseware/coursewareAdd"
import coursewareDetail from "@/views/courseware/coursewareDetail"
import coursewareUploadVideo from "@/views/courseware/coursewareUploadVideo"
import coursewareList from "@/views/courseware/coursewareList"
import coursewareLookVideo from "@/views/courseware/coursewareLookVideo"
import flash from "@/views/courseware/flash"

import dangj from "@/views/dangj/index.vue"
import dangjCreate from "@/views/dangj/dangjCreate.vue"
import dangjDetail from "@/views/dangj/dangjDetail.vue";

import zhengc from "@/views/zhengc/index.vue"
import zhengcCreate from "@/views/zhengc/zhengcCreate.vue";
import zhengcDetail from "@/views/zhengc/zhengcDetail.vue";

/*校园安全*/
import schoolSafe from "@/views/schoolSafe/index.vue"
import schoolSafeCreate from "@/views/schoolSafe/schoolSafeCreate.vue";
import schoolSafeDetail from "@/views/schoolSafe/schoolSafeDetail.vue";

import traCourse from "@/views/traCourse/index"
import traCourseAdd from "@/views/traCourse/traCourseAdd"
import traCourseDetail from "@/views/traCourse/traCourseDetail"
import traCourseUploadVideo from "@/views/traCourse/traCourseUploadVideo"
import traCourseList from "@/views/traCourse/traCourseList"

import teachResearch from "@/views/teachResearch/index"
import teachResearchAdd from "@/views/teachResearch/teachResearchAdd"
import teachResearchDetail from "@/views/teachResearch/teachResearchDetail"
import groupEdit from "@/views/teachResearch/groupEdit.vue";

import achieve from "@/views/achieve/index"
import achieveAdd from "@/views/achieve/achieveAdd"
import achieveDetail from "@/views/achieve/achieveDetail"

import studioList from "@/views/famousPrincipal/studioList"
import studioManage from "@/views/famousPrincipal/studioManage"

import workBrieManage from "@/views/famousPrincipal/workBrieManage"

import teachStudioList from "@/views/famousPrincipal/teachStudioList"
import teachStudioManage from "@/views/famousPrincipal/teachStudioManage"

import studioAdd from "@/views/famousPrincipal/studioAdd.vue"
import studioDetail from "@/views/famousPrincipal/studioDetail"
import studioRoomDetail from "@/views/famousPrincipal/studioRoomDetail"

import messageCenter from "@/views/messageCenter/index"
import systemCenter from "@/views/messageCenter/systemCenter"

import collectionCenter from "@/views/collectionCenter/index"

import myFollow from "@/views/myFollow/index"

import userInfo from "@/views/personApp/userInfo"

import uesrManage from "@/views/uesrManage/index"
import uesrAdd from "@/views/uesrManage/uesrAdd"
import userConfig from "@/views/uesrManage/userConfig.vue"

import ptStatistics from "@/views/statistics/ptStatistics"

import jkyStatistics from "@/views/statistics/jkyStatistics"

import szpxStatistics from "@/views/statistics/szpxStatistics"

import msgzsStatistics from "@/views/statistics/msgzsStatistics"

import principalStudio from "@/views/statistics/principalStudio"

import homePage from "@/views/public/homePage"

import fileFill from "@/views/teacherFile/fileFill"
import fileAllocation from "@/views/teacherFile/fileAllocation"
import fileManage from "@/views/teacherFile/fileManage"
import fileList from "@/views/teacherFile/fileList"
import fileStatistics from "@/views/teacherFile/fileStatistics"
import expert from "@/views/expert/index"
import expertAdd from "@/views/expert/expertAdd"
import checkList from "@/views/teacherFile/checkList"
import setFileCheck from "@/views/teacherFile/setFileCheck"

import trainStat from "@/views/stat/trainStat"
import teachingStat from "@/views/stat/teachingStat"

import indexs from "@/views/index.vue"

import teachStudioState from "@/views/studio/teaStudioState"
import teaStudioList from "@/views/studio/teaStudioList"
import teaStudioManager from "@/views/studio/teaStudioManager";

import studioInfo from "@/views/studio/studioInfo"

import headmasterStudioState from "@/views/studio/headmasterStudioState"
import rectorStudioList from "@/views/studio/rectorStudioList"
import rectorStudioManager from "@/views/studio/rectorStudioManager";

import msgCenter from "@/views/messageCenter/msgCenter";
import taskCenter from "@/views/messageCenter/taskCenter"
import teacherArchives from "@/views/personApp/teacherArchives.vue"
import growthCenter from "@/views/personApp/growthCenter.vue"

import statDashboard from "@/views/stat/statDashboard.vue";
import schoolDashboard from "@/views/stat/schoolDashboard.vue";
import areaDashboard from "@/views/stat/areaDashboard.vue";
/*Web用户端*/
import welHome from "@/views/home/welHome.vue";
import teaStudioHome from "@/views/home/teaStudioHome";
import rectorStudioHome from "@/views/home/rectorStudioHome";
import homeStudioDetail from "@/views/home/homeStudioDetail"
import homeResourceCentre from "@/views/home/homeResourceCentre";
import homeAiAide from "@/views/home/homeAiAide.vue";
import homeMentality from "@/views/home/homeMentality.vue";
import homeEduResearch from "@/views/home/homeEduResearch.vue";
import homeNews from "@/views/home/homeNews.vue";
import homeTeacherTrain from "@/views/home/homeTeacherTrain.vue";
import homeTeachResearch from "@/views/home/homeTeachResearch.vue";
import homeUserCenter from "@/views/home/homeUserCenter.vue";
import homeStudioNews from "@/views/home/homeStudioNews.vue";
import homeNewsCentre from "@/views/home/homeNewsCentre.vue";
import homeTrendsCentre from "@/views/home/homeTrendsCentre.vue";
import homeManagerCenter from "@/views/home/homeManagerCenter.vue";
import homeEvaStat from "@/views/home/homeEvaStat.vue";
import homeEditOffice from "@/views/home/homeEditOffice.vue";
import homeOfficeLink from "@/views/home/homeOfficeLink.vue";
import homeFlash from "@/views/home/homeFlash.vue";
import homeJxssReport from "@/views/home/homeJxssReport.vue";
import homeYxktReport from "@/views/home/homeYxktReport.vue";
import homeArchive from "@/views/home/homeArchive.vue";
import homeExamPaper from "@/views/home/HomeExamPaper.vue";
import homePaperCenter from "@/views/home/HomePaperCenter.vue";
import appExamPaper from "@/views/home/appExamPaper.vue"
import appPaperCenter from "@/views/home/appPaperCenter.vue"
import homeTeachEvaluation from "@/views/home/homeTeachEvaluation.vue"

/*视频分析*/
import courseAnalyse from "@/views/courseAnalyse/index.vue";
import courseAnalyseCreate from "@/views/courseAnalyse/courseAnalyseCreate.vue";
import courseReportInfo from "@/views/courseAnalyse/courseReportInfo.vue";
import courseAnalyseReportInfo from "@/views/courseAnalyse/courseAnalyseReportInfo.vue";


import analyseAdmin from "@/views/analyseAdmin/index.vue";
import analyseDetail from "@/views/analyseAdmin/analyseDetail.vue";
import orgAnalyseDetail from "@/views/analyseAdmin/orgAnalyseDetail.vue";
import orgCourseAnalyseCreate from "@/views/analyseAdmin/orgCourseAnalyseCreate.vue";

/*美育浸润*/
import myjrIndex from "@/views/myjr/index.vue"
import myjrCreate from "@/views/myjr/myjrCreate.vue";
import myjrDetail from "@/views/myjr/myjrDetail.vue";
/*推荐书目*/
import bookIndex from "@/views/book/index.vue"
import bookCreate from "@/views/book/bookCreate.vue";
import bookDetail from "@/views/book/bookDetail.vue";
/*主题活动*/
import eventIndex from "@/views/event/index.vue";
import eventCreate from "@/views/event/eventCreate.vue";
import eventDetail from "@/views/event/eventDetail.vue";
/*时间活动*/
import practiceIndex from "@/views/practice/index.vue";
import practiceCreate from "@/views/practice/practiceCreate.vue";

/*临时看板*/
import jxcgBorder from "@/views/board/jxcgBorder"
import jhjcBorder from "@/views/board/jhjcBorder";
import fzsjBorder from "@/views/board/fzsjBorder";
import ktyjBorder from "@/views/board/ktyjBorder";
import dycgBorder from "@/views/board/dycgBorder";
import jsjhBorder from "@/views/board/jsjhBorder";

/*数据统计看板*/
import teacherCockpit from "@/views/board/teacherCockpit.vue";
/*人文美育*/
import videoLibraryManage from "@/views/humanity/videoLibraryManage";
import humanityCourseManager from "@/views/humanity/humanityCourseManager";
import humanityCourseCreate from "@/views/humanity/humanityCourseCreate";
import humanityCourseDetail from "@/views/humanity/humanityCourseDetail";
import humanityLibraryManage from "@/views/humanity/humanityLibraryManage";
import subjectFusionInfo from "@/views/humanity/subjectFusionInfo";
import museumCourseList from "@/views/humanity/museumCourseList";
import searchCourseList from "@/views/humanity/searchCourseList";
import humanityCourseInfo from "@/views/humanity/humanityCourseInfo";
import searchHumanityVideoList from "@/views/humanity/searchHumanityVideoList";
/*App打包*/
import appEduResearch from "@/views/app/appEduResearch.vue";

/*日清周结*/
import rqzjIndex from "@/views/rqzj/index.vue";
import rqzjManager from "@/views/rqzj/rqzjManager.vue";
import rqzjView from "@/views/rqzj/rqzjView.vue";
/*三层量分定做*/
import sclfdzIndex from "@/views/sclfdz/index.vue";
import sclfdzManager from "@/views/sclfdz/sclfdzManager.vue";
import sclfdzView from "@/views/sclfdz/sclfdzView.vue";
/* 分层作业 */
import homeworkManager from "@/views/homework/homeworkManager.vue"
import homeworkView from "@/views/homework/homeworkView.vue"
/* 英语强化 */
import englishImporveIndex from "@/views/englishImprove/englishImproveIndex.vue"
import englishImproveCreate from "@/views/englishImprove/englishImproveCreate.vue"
import englishImproveUploadVideo from "@/views/englishImprove/englishImproveUploadVideo.vue"
import englishImproveCourseDetail from '@/views/englishImprove/englishImproveCourseDetail.vue';
import englishImproveViewCourse from '@/views/englishImprove/englishImproveViewCourse.vue';
/* 学霸讲专业 */
import professionIndex from "@/views/profession/professionIndex.vue"
import professionCreate from "@/views/profession/professionCreate.vue"
import professionUploadVideo from "@/views/profession/professionUploadVideo.vue"
import professionCourseDetail from '@/views/profession/professionCourseDetail.vue';
import professionViewCourse from '@/views/profession/professionViewCourse.vue';
/* 圈考点 */
import examPointManager from "@/views/examPoint/examPointManager.vue"
import examPointView from "@/views/examPoint/examPointView.vue"
/* 专业知晓 */
import professionKnowledgeManager from "@/views/professionKnowledge/professionKnowledgeManager.vue"
import professionKnowledgeView from "@/views/professionKnowledge/professionKnowledgeView.vue"
/* 赢在规划 */
import admissionManager from "@/views/admission/admissionManager.vue"
import admissionView from "@/views/admission/admissionView.vue"
/* 热搜题 */
import hotQuesManager from "@/views/hotQues/hotQuesManager.vue"
import hotQuesView from "@/views/hotQues/hotQuesView.vue"
/* 学校文化中心-素材中心（学校文化） */
import materialManager from "@/views/material/materialManager.vue"
import materialView from "@/views/material/materialView.vue"
import materialCDRView from "@/views/material/materialCDRView.vue"

/* 璇玑AI */
import homeAiInstructor from "@/views/home/homeAiInstructor.vue"

/* 校园安全食品类 */
import schoolSafeVideoManager from "@/views/schoolSafeVideo/schoolSafeVideoManager.vue"

/* 心理健康视频 */
import mentalHealthVideoManager from "@/views/mentalHealthVideo/mentalHealthVideoManager.vue"

/* 心理健康-政策 */
import mentalHealth from "@/views/mentalHealth/index.vue"
import mentalHealthCreate from "@/views/mentalHealth/mentalHealthCreate.vue";
import mentalHealthDetail from "@/views/mentalHealth/mentalHealthDetail.vue";

const routes = [
    //App打包
    { path: '/app/research', name: 'appEduResearch', meta: { title: '恒岳教研-一体化教研' }, component: appEduResearch },

    { path: '/', redirect: '/hyedu/wel' },
    { path: '/hyedu/wel', name: 'welHome', meta: { title: '欢迎来到恒岳教研' }, component: welHome },
    { path: '/hyedu/teastudio', name: 'teaStudioHome', meta: { title: '恒岳教研-名师工作室' }, component: teaStudioHome },
    { path: '/hyedu/rectorstudio', name: 'rectorStudioHome', meta: { title: '恒岳教研-名校长工作室' }, component: rectorStudioHome },
    { path: '/hyedu/studiodetail', name: 'homeStudioDetail', meta: { title: '恒岳教研-工作室详情' }, component: homeStudioDetail },
    { path: '/hyedu/resource', name: 'homeResourceCentre', meta: { title: '恒岳教研-资源中心' }, component: homeResourceCentre },
    { path: '/hyedu/aiaide', name: 'homeAiAide', meta: { title: '恒岳教研-AI教师助手' }, component: homeAiAide },
    { path: '/hyedu/mentality', name: 'homeMentality', meta: { title: '恒岳教研-心理评价' }, component: homeMentality },
    { path: '/hyedu/research', name: 'homeEduResearch', meta: { title: '恒岳教研-一体化教研' }, component: homeEduResearch },
    { path: '/hyedu/news', name: 'homeNews', meta: { title: '恒岳教研-新闻资讯' }, component: homeNews },
    { path: '/hyedu/train', name: 'homeTeacherTrain', meta: { title: '恒岳教研-师资培训' }, component: homeTeacherTrain },
    { path: '/hyedu/tearesearch', name: 'homeTeachResearch', meta: { title: '恒岳教研-教科研' }, component: homeTeachResearch },
    { path: '/hyedu/usercenter', name: 'homeUserCenter', meta: { title: '恒岳教研-用户中心' }, component: homeUserCenter },
    { path: '/hyedu/newscenter', name: 'homeNewsCentre', meta: { title: '恒岳教研-新闻资讯' }, component: homeNewsCentre },
    { path: '/hyedu/trendscenter', name: 'homeTrendsCentre', meta: { title: '恒岳教研-工作室动态' }, component: homeTrendsCentre },
    { path: '/hyedu/managercenter', name: 'homeManagerCenter', meta: { title: '恒岳教研-我的管理' }, component: homeManagerCenter },

    { path: '/hyedu/studionews', name: 'homeStudioNews', meta: { title: '恒岳教研-工作室资讯动态' }, component: homeStudioNews },
    { path: '/hyedu/evaStat', name: 'homeEvaStat', meta: { title: '恒岳教研-听评课量表统计' }, component: homeEvaStat },
    { path: '/hyedu/editOffice', name: 'homeEditOffice', meta: { title: '恒岳教研-Office文件编辑' }, component: homeEditOffice },
    { path: '/hyedu/officeLink', name: 'homeOfficeLink', meta: { title: '恒岳教研-Office超链接' }, component: homeOfficeLink },
    { path: '/hyedu/flash', name: 'homeFlash', meta: { title: '恒岳教研-课件播放' }, component: homeFlash },
    { path: '/hyedu/jxssReport', name: 'homeJxssReport', meta: { title: '恒岳教研-课堂分析报告' }, component: homeJxssReport },
    { path: '/hyedu/yxktReport', name: 'homeYxktReport', meta: { title: '恒岳教研-课堂分析报告' }, component: homeYxktReport },
    { path: '/hyedu/archive', name: 'homeArchive', meta: { title: '恒岳教研-教师档案' }, component: homeArchive },
    { path: '/hyedu/ques', name: 'homeExamPaper', meta: { title: '恒岳教研-试题组卷' }, component: homeExamPaper },
    { path: '/hyedu/paper', name: 'homePaperCenter', meta: { title: '恒岳教研-组卷中心' }, component: homePaperCenter },
    /* 组卷-其他调用 */
    { path: '/hyedu/paperQues', name: 'appExamPaper', meta: { title: '恒岳教研-试题组卷' }, component: appExamPaper },
    { path: '/hyedu/paperCenter', name: 'appPaperCenter', meta: { title: '恒岳教研-组卷中心' }, component: appPaperCenter },
    { path: '/hyedu/classevaluate', name: 'homeTeachEvaluation', meta: { title: '恒岳教研-课堂评估' }, component: homeTeachEvaluation },
    { path: '/hyedu/aiInstructor', name: 'homeAiInstructor', meta: { title: '恒岳教研-超级教研员' }, component: homeAiInstructor },

    { path: '/login', name: '登录-恒岳教研', meta: { title: '登录-恒岳教研' }, component: UserLogin },
    { path: '/inviteMember', name: '场景邀请成员', meta: { title: '恒岳教研' }, component: InviteMember },
    { path: '/expertJoin', name: '专家入库并加入协同备课', meta: { title: '恒岳教研' }, component: expertJoin },
    { path: '/codeLogin', name: '用户验证码登录', meta: { title: '用户验证码登录' }, component: CodeLogin },
    { path: '/register', name: '用户注册', meta: { title: '用户注册' }, component: Register },
    { path: '/resetPwd', name: '用户重置密码', meta: { title: '用户重置密码' }, component: ResetPwd },
    { path: '/oauth/authorize', name: '用户授权登录', meta: { title: '用户授权登录' }, component: AuthorizedLogin },
    { path: '/newsShare', name: '新闻咨询分享', meta: { title: '恒岳教研' }, component: newsShare },

    { path: '/policy', name: '恒岳教研隐私政策', meta: { title: '恒岳教研隐私政策' }, component: Policy },
    { path: '/workBook', name: '群笔记操作手册', meta: { title: '群笔记操作手册' }, component: WorkBook },
    { path: '/editor', name: '编辑器', meta: { title: '编辑器' }, component: editor },

    { path: '/lessonFileDetail', name: '协同备课-查看文件', meta: { title: '查看文件' }, component: lessonFileDetail },
    { path: '/lessonFileGADetail', name: '协同备课-查看', meta: { title: '协同备课-查看' }, component: lessonFileGADetail },
    { path: '/lessonDiscuss', name: '研讨-协同备课', meta: { title: '协同备课-去研讨' }, component: lessonDiscuss },
    { path: '/viewLessonDiscuss', name: '协同备课查看研讨', meta: { title: '协同备课查看研讨' }, component: viewLessonDiscuss },
    { path: "/lookflash", name: "互动元件", meta: { title: '互动元件' }, component: flash },

    { path: '/fileFill', name: '档案填报', meta: { title: '档案填报' }, component: fileFill },
    { path: '/fileFillck', name: '档案查看', meta: { title: '档案查看' }, component: fileFill },
    { path: '/fileStatistics', name: '驾驶舱', meta: { title: '驾驶舱' }, component: fileStatistics },
    { path: '/statDashboard', name: '统计看板', meta: { title: '统计看板' }, component: statDashboard },
    { path: '/schoolDashboard', name: '学校综合数据看板', meta: { title: '学校综合数据看板' }, component: schoolDashboard },
    { path: '/areaDashboard', name: '区域综合数据看板', meta: { title: '区域综合数据看板' }, component: areaDashboard },

    { path: '/expert', name: '专家库', meta: { title: '专家库' }, component: expert },
    { path: '/expertAdd', name: '新增专家', meta: { title: '新增专家' }, component: expertAdd },
    { path: '/expertck', name: '专家查看', meta: { title: '专家查看' }, component: expertAdd },
    { path: '/experted', name: '编辑专家', meta: { title: '编辑专家' }, component: expertAdd },

    { path: '/jxcgBorder', name: '教学成果看板', meta: { title: '教学成果看板' }, component: jxcgBorder },
    { path: '/jhjcBorder', name: '均衡检测看板', meta: { title: '均衡检测看板' }, component: jhjcBorder },
    { path: '/fzsjBorder', name: '发展数据看板', meta: { title: '发展数据看板' }, component: fzsjBorder },
    { path: '/ktyjBorder', name: '课堂研究看板', meta: { title: '课堂研究看板' }, component: ktyjBorder },
    { path: '/dycgBorder', name: '德育成果看板', meta: { title: '德育成果看板' }, component: dycgBorder },
    { path: '/jsjhBorder', name: '教师均衡发展驾驶舱', meta: { title: '教师均衡发展驾驶舱' }, component: teacherCockpit },

    { path: '/hyedu/home', name: '恒岳教研主页', meta: { title: '恒岳教研主页' }, component: homePage },
    // { path: '/hyedu/teastudio', name: '恒岳教研-名师工作室', meta: { title: '恒岳教研-名师工作室' }, component: studioHome },
    // { path: '/hyedu/rectrostudio', name: '恒岳教研-名校长工作室', meta: { title: '恒岳教研-名校长工作室' }, component: rectorStudioHome },


    {
        path: '/home',
        name: "恒岳教研-首页",
        component: GroupHome,
        redirect: "/indexs",
        meta: { title: '首页-恒岳教研管理中心' },
        children: [
            {
                path: '/indexs',
                component: indexs,
                meta: { title: '首页' },
            },

            { path: "/arrayMaintenance", name: "arrayMaintenance", meta: { title: '组织结构', keepAlive: true }, component: ArrayMaintenance },

            { path: "/groupSet", name: "groupSet", meta: { title: '群组维护', keepAlive: true }, component: GroupSet },

            { path: "/groupSetAdd", name: "groupSetAdd", meta: { title: '新增群组', hidden: true }, component: GroupSetAdd },

            { path: "/news", name: "news", meta: { title: '新闻资讯管理', keepAlive: true }, component: news },
            { path: "/newsAdd", name: "newsAdd", meta: { title: '新增新闻资讯', hidden: true }, component: newsAdd },
            { path: "/newsDetail", name: "newsDetail", meta: { title: '新闻详情', hidden: true }, component: newsDetail },

            { path: "/classLibrary", name: "classLibrary", meta: { title: '教程库管理', keepAlive: true }, component: classLibrary },
            { path: "/classLibraryAdd", name: "classLibraryAdd", meta: { title: '新增课本', hidden: true }, component: classLibraryAdd },
            { path: "/classLibraryDetail", name: "classLibraryDetail", meta: { title: '课本详情', hidden: true }, component: classLibraryDetail },

            { path: "/banner", name: "banner", meta: { title: 'banner管理', keepAlive: true }, component: banner },
            { path: "/bannerAdd", name: "bannerAdd", meta: { title: '新增banner', hidden: true }, component: bannerAdd },
            { path: "/bannerDetail", name: "bannerDetail", meta: { title: 'banner详情', hidden: true }, component: bannerDetail },

            { path: "/bannerNotice", name: "bannerNotice", meta: { title: '通知banner管理', keepAlive: true }, component: bannerNotice },
            { path: "/bannerNoticeAdd", name: "bannerNoticeAdd", meta: { title: '新增通知banner', hidden: true }, component: bannerNoticeAdd },
            { path: "/bannerNoticeDetail", name: "bannerNoticeDetail", meta: { title: '通知banner详情', hidden: true }, component: bannerNoticeDetail },

            { path: "/lesson", name: "lesson", meta: { title: '协同备课', keepAlive: true }, component: lesson },
            { path: "/lessonAdd", name: "lessonAdd", meta: { title: '新增协同备课', hidden: true }, component: lessonAdd },
            { path: "/lessonDetail", name: "lessonDetail", meta: { title: '协同备课详情', hidden: true }, component: lessonDetail },
            { path: "/lessonOwnerDetail", name: "lessonOwnerDetail", meta: { title: '个人备课详情', hidden: true }, component: lessonOwnerDetail },
            { path: "/lessttShare", name: "lessonShare", meta: { title: '已完备课', }, component: lessonShare },

            { path: "/myLess", name: "myLess", meta: { title: '个人备课', keepAlive: true }, component: myLess },
            { path: "/shareApply", name: "shareApply", meta: { title: '备课审核', keepAlive: true }, component: shareApply },

            { path: "/evaluation", name: "evaluation", meta: { title: '听评教研', keepAlive: true }, component: evaluation },
            { path: "/evaluationAdd", name: "evaluationAdd", meta: { title: '新增听评教研', hidden: true }, component: evaluationAdd },
            { path: "/evaluationDetail", name: "evaluationDetail", meta: { title: '听评教研详情', hidden: true }, component: evaluationDetail },

            { path: "/rateScale", name: "rateScale", meta: { title: '听评课量表', keepAlive: true }, component: rateScale },

            { path: "/train", name: "train", meta: { title: '师资培训', keepAlive: true }, component: train },
            { path: "/trainAdd", name: "trainAdd", meta: { title: '新增师资培训', hidden: true }, component: trainAdd },
            { path: "/trainDetail", name: "trainDetail", meta: { title: '师资培训详情', hidden: true }, component: trainDetail },
            { path: "/trainCourseLookVideo", name: "trainCourseLookVideo", meta: { title: '师资培训查看视频', hidden: true }, component: trainCourseLookVideo },

            { path: "/videoLibrary", name: "videoLibrary", meta: { title: '培训视频库', keepAlive: true }, component: videoLibrary },
            { path: "/videoLibraryAdd", name: "videoLibraryAdd", meta: { title: '新增培训视频', hidden: true }, component: videoLibraryAdd },

            { path: "/lead", name: "lead", meta: { title: '课题引领', keepAlive: true }, component: lead },
            { path: "/leadAdd", name: "leadAdd", meta: { title: '新增课题引领', hidden: true }, component: leadAdd },
            { path: "/leadDetail", name: "leadDetail", meta: { title: '课题引领详情', hidden: true }, component: leadDetail },

            { path: "/topic", name: "topic", meta: { title: '课题引领', keepAlive: true }, component: topic },
            { path: "/topicAdd", name: "topicAdd", meta: { title: '创建课题', hidden: true }, component: topicAdd },
            { path: "/topicManager", name: "topicManager", meta: { title: '课题管理', hidden: true }, component: topicManager },
            { path: "/subTopicManager", name: "subTopicManager", meta: { title: '子课题管理', hidden: true }, component: subTopicManager },
            { path: "/topicCheck", name: "topicCheck", meta: { title: '子课题审核', hidden: true }, component: topicCheck },
            { path: "/topicBmCheck", name: "topicBmCheck", meta: { title: '子课题报名信息审核', hidden: true }, component: topicBmCheck },
            { path: "/topicKtCheck", name: "topicKtCheck", meta: { title: '子课题开题资料审核', hidden: true }, component: topicKtCheck },
            { path: "/topicZqCheck", name: "topicZqCheck", meta: { title: '子课题中期资料审核', hidden: true }, component: topicZqCheck },
            { path: "/topicJtCheck", name: "topicJtCheck", meta: { title: '子课题结题验收审核', hidden: true }, component: topicJtCheck },
            { path: "/topicRelease", name: "topicRelease", meta: { title: '课题发布', hidden: true }, component: topicRelease },

            { path: "/topicApply", name: "topicApply", meta: { title: '申报审核', keepAlive: true }, component: topicApply },
            { path: "/topicApplyDetail", name: "topicApplyDetail", meta: { title: '审核详情', hidden: true }, component: topicApplyDetail },
            { path: "/activitApplyDetail", name: "activitApplyDetail", meta: { title: '审核详情', hidden: true }, component: activitApplyDetail },

            { path: "/race", name: "race", meta: { title: '教研赛事', keepAlive: true }, component: race },
            { path: "/raceAdd", name: "raceAdd", meta: { title: '新增教研赛事', hidden: true }, component: raceAdd },
            { path: "/raceCreate", name: "raceCreate", meta: { title: '创建教研赛事', hidden: true }, component: raceCreate },
            { path: "/raceDetail", name: "raceDetail", meta: { title: '教研赛事详情', hidden: true }, component: raceDetail },
            { path: "/raceManager", name: "raceManager", meta: { title: '竞赛管理', hidden: true }, component: raceManager },
            { path: "/raceSign", name: "raceSignInfo", meta: { title: '竞赛报名资料', hidden: true }, component: raceSignInfo},
            { path: "/csRaceSign", name: "csRaceSignInfo", meta: { title: '竞赛报名初审查看', hidden: true }, component: csRaceSignInfo},
            { path: "/fsRaceSign", name: "fsRaceSignInfo", meta: { title: '竞赛报名复审查看', hidden: true }, component: fsRaceSignInfo},
            { path: "/zsRaceSign", name: "zsRaceSignInfo", meta: { title: '竞赛报名终审查看', hidden: true }, component: zsRaceSignInfo},
            { path: "/raceScale", name: "raceScale", meta: { title: '竞赛量表', hidden: true }, component: raceScale},

            { path: "/activity", name: "activity", meta: { title: '专题活动', keepAlive: true }, component: activity },
            { path: "/activityAdd", name: "activityAdd", meta: { title: '新增专题活动', hidden: true }, component: activityAdd },
            { path: "/activityDetail", name: "activityDetail", meta: { title: '专题活动详情', hidden: true }, component: activityDetail },
            { path: "/activityCreate", name: "activityCreate", meta: { title: '创建专题活动', hidden: true }, component: activityCreate },
            { path: "/activityScale", name: "activityScale", meta: { title: '专题活动量表', hidden: true }, component: activityScale },
            { path: "/activityManager", name: "activityManager", meta: { title: '专题活动管理', hidden: true }, component: activityManager },
            { path: "/activitySign", name: "activitySign", meta: { title: '活动报名资料', hidden: true }, component: bmActivitySignInfo },
            { path: "/csActivitySign", name: "csActivitySign", meta: { title: '活动初审资料', hidden: true }, component: csActivitySignInfo },
            { path: "/fsActivitySign", name: "fsActivitySign", meta: { title: '活动复审资料', hidden: true }, component: fsActivitySignInfo },
            { path: "/zsActivitySign", name: "zsActivitySign", meta: { title: '活动终审资料', hidden: true }, component: zsActivitySignInfo },

            { path: "/studioList", name: "studioList", meta: { title: '名校长工作室列表', keepAlive: true }, component: studioList },
            { path: "/studioManage", name: "studioManage", meta: { title: '名校长工作室管理', keepAlive: true }, component: studioManage },

            { path: "/teachStudioList", name: "teachStudioList", meta: { title: '名师工作室列表', keepAlive: true }, component: teachStudioList },
            { path: "/teachStudioManage", name: "teachStudioManage", meta: { title: '名师工作室管理', keepAlive: true }, component: teachStudioManage },
            /*名师工作室新*/
            { path: "/teaState", name: "teaState", meta: { title: '名师工作室概览', keepAlive: true }, component: teachStudioState },
            { path: "/teaStudio", name: "teaStudio", meta: { title: '名师工作室查询', keepAlive: true }, component: teaStudioList },
            { path: "/teaStudioManage", name: "teaStudioManage", meta: { title: '名师工作室管理', keepAlive: true }, component: teaStudioManager },
            /*名校长工作室新*/
            { path: "/rectorState", name: "headmasterState", meta: { title: '名校长工作室概览', keepAlive: true }, component: headmasterStudioState },
            { path: "/rectorStudio", name: "rectorStudio", meta: { title: '名校长工作室查询', keepAlive: true }, component: rectorStudioList },
            { path: "/rectorStudioManager", name: "rectorStudioManager", meta: { title: '名校长工作室管理', keepAlive: true }, component: rectorStudioManager },

            { path: "/studioinfo", name: "studioinfo", meta: { title: '工作室详情', hidden: true }, component: studioInfo },


            { path: "/studioInformation", name: "studioInformation", meta: { title: '工作室资讯', keepAlive: true }, component: studioAdd },
            { path: "/studioDetail", name: "studioDetail", meta: { title: '工作室资讯', hidden: true }, component: studioDetail },
            { path: "/studioRoomDetail", name: "studioRoomDetail", meta: { title: '工作室详情', hidden: true }, component: studioRoomDetail },
            { path: "/workBrieManage", name: "workBrieManage", meta: { title: '工作简报管理', hidden: true }, component: workBrieManage },

            { path: "/handleApply", name: "handleApply", meta: { title: '优课审核', keepAlive: true }, component: handleApply },
            { path: "/handleApplyDetail", name: "handleApplyDetail", meta: { title: '优课审核详情', hidden: true }, component: handleApplyDetail },

            { path: "/famousCourse", name: "famousCourse", meta: { title: '资源管理' }, component: famousCourse },
            { path: "/famousCourseAdd", name: "famousCourseAdd", meta: { title: '新增名师优课', hidden: true }, component: famousCourseAdd },
            { path: "/famousCourseDetail", name: "famousCourseDetail", meta: { title: '名师优课详情', hidden: true }, component: famousCourseDetail },
            { path: "/famousCourseUploadVideo", name: "famousCourseUploadVideo", meta: { title: '名师优课上传视频', hidden: true }, component: famousCourseUploadVideo },
            { path: "/famousCourseHumanityVideo", name: "famousCourseHumanityVideo", meta: { title: '资源中心视频管理', hidden: true }, component: famousCourseHumanityVideo },


            { path: "/studioCourseManager", name: "studioCourseManager", meta: { title: '工作室课程资源管理', hidden: true }, component: studioCourseManager },
            { path: "/studioCourseCreate", name: "studioCourseCreate", meta: { title: '工作室课程资源', hidden: true }, component: studioCourseCreate },
            { path: "/studioCourseInfo", name: "studioCourseInfo", meta: { title: '工作室课程资源', hidden: true }, component: studioCourseInfo },
            { path: "/studioViewCourse", name: "studioViewCourse", meta: { title: '工作室课程资源', hidden: true }, component: studioViewCourse },


            { path: "/famousCourseHumanityLookVideo", name: "famousCourseHumanityLookVideo", meta: { title: '名师优课查看视频', hidden: true }, component: famousCourseHumanityLookVideo },
            { path: "/famousCourseLookVideo", name: "famousCourseLookVideo", meta: { title: '名师优课查看视频', hidden: true }, component: famousCourseLookVideo },
            { path: "/famousGspList", name: "famousGspList", meta: { title: '高水平示范课' }, component: famousList },
            { path: "/famousQbList", name: "famousQbList", meta: { title: '区本课程' }, component: famousList },
            { path: "/famousJbList", name: "famousJbList", meta: { title: '校本课程' }, component: famousList },
            { path: "/famousKhList", name: "famousKhList", meta: { title: '课后服务' }, component: famousList },
            { path: "/famousAIList", name: "famousAIList", meta: { title: '人工智能' }, component: famousList },

            { path: "/courseware", name: "courseware", meta: { title: '课件管理', keepAlive: true }, component: courseware },
            { path: "/coursewareAdd", name: "coursewareAdd", meta: { title: '新增课件', hidden: true }, component: coursewareAdd },
            { path: "/coursewareDetail", name: "coursewareDetail", meta: { title: '课件详情', hidden: true }, component: coursewareDetail },
            { path: "/coursewareUploadVideo", name: "coursewareUploadVideo", meta: { title: '上传课件', hidden: true }, component: coursewareUploadVideo },
            { path: "/coursewareLookVideo", name: "coursewareLookVideo", meta: { title: '查看课件', hidden: true }, component: coursewareLookVideo },
            { path: "/coursewareList", name: "coursewareList", meta: { title: '互动课件', keepAlive: true }, component: coursewareList },

            { path: "/dangj", name: "dangj", meta: { title: '党建引领管理', keepAlive: true }, component: dangj },
            { path: "/dangjCreate", name: "dangjCreate", meta: { title: '党建引领', keepAlive: true }, component: dangjCreate },
            { path: "/dangjDetail", name: "dangjDetail", meta: { title: '党建引领', keepAlive: true }, component: dangjDetail },

            { path: "/zhengc", name: "zhengc", meta: { title: '政策法规管理', keepAlive: true }, component: zhengc },
            { path: "/zhengcCreate", name: "zhengcCreate", meta: { title: '政策法规', keepAlive: true }, component: zhengcCreate },
            { path: "/zhengcDetail", name: "zhengcDetail", meta: { title: '政策法规', keepAlive: true }, component: zhengcDetail },

            { path: "/schoolSafe", name: "schoolSafe", meta: { title: '校园安全-政策', keepAlive: true }, component: schoolSafe },
            { path: "/schoolSafeCreate", name: "schoolSafeCreate", meta: { title: '校园安全-政策', keepAlive: true }, component: schoolSafeCreate },
            { path: "/schoolSafeDetail", name: "schoolSafeDetail", meta: { title: '校园安全-政策', keepAlive: true }, component: schoolSafeDetail },
            
            { path: "/schoolSafeVideo", name: "schoolSafeVideoManager", meta: { title: '校园安全-视频', keepAlive: true }, component: schoolSafeVideoManager },

            { path: "/mentalHealthVideo", name: "mentalHealthVideoManager", meta: { title: '心理健康-视频', keepAlive: true }, component: mentalHealthVideoManager },

            { path: "/mentalHealth", name: "mentalHealth", meta: { title: '心理健康-政策', keepAlive: true }, component: mentalHealth },
            { path: "/mentalHealthCreate", name: "mentalHealthCreate", meta: { title: '心理健康-政策', keepAlive: true }, component: mentalHealthCreate },
            { path: "/mentalHealthDetail", name: "mentalHealthDetail", meta: { title: '心理健康-政策', keepAlive: true }, component: mentalHealthDetail },

            { path: "/traCourse", name: "traCourse", meta: { title: '培训视频管理' }, component: traCourse },
            { path: "/traCourseAdd", name: "traCourseAdd", meta: { title: '新增培训视频', hidden: true }, component: traCourseAdd },
            { path: "/traCourseDetail", name: "traCourseDetail", meta: { title: '培训视频详情', hidden: true }, component: traCourseDetail },
            { path: "/traCourseUploadVideo", name: "traCourseUploadVideo", meta: { title: '培训视频上传视频', hidden: true }, component: traCourseUploadVideo },
            { path: "/traCourseList", name: "traCourseList", meta: { title: '师资培训课程' }, component: traCourseList },

            { path: "/userInfo", name: "userInfo", meta: { title: '用户中心' }, component: userInfo },
            // { path: "/hyedu/userInfo", name: "userInfo", meta: { title: '用户中心' }, component: userInfo },

            { path: "/teachResearch", name: "teachResearch", meta: { title: '群组管理' }, component: teachResearch },
            { path: "/teachResearchAdd", name: "teachResearchAdd", meta: { title: '新增群组', hidden: true }, component: teachResearchAdd },
            { path: "/teachResearchDetail", name: "teachResearchDetail", meta: { title: '群组详情', hidden: true }, component: teachResearchDetail },
            { path: "/groupEdit", name: "groupEdit", meta: { title: '工作室信息', hidden: true }, component: groupEdit },

            { path: "/achieve", name: "achieve", meta: { title: '成果展示' }, component: achieve },
            { path: "/achieveAdd", name: "achieveAdd", meta: { title: '新增成果展示', hidden: true }, component: achieveAdd },
            { path: "/achieveDetail", name: "achieveDetail", meta: { title: '成果展示详情', hidden: true }, component: achieveDetail },

            { path: "/systemCenter", name: "systemCenter", meta: { title: '消息中心' }, component: systemCenter },

            { path: "/messageCenter", name: "messageCenter", meta: { title: '消息中心' }, component: messageCenter },

            { path: "/usermsg", name: "msgCenter", meta: { title: '消息中心' }, component: msgCenter },
            { path: "/taskmsg", name: "taskCenter", meta: { title: '消息中心' }, component: taskCenter },

            { path: "/teacherArchives", name: "teacherArchives", meta: { title: '教师档案' }, component: teacherArchives },
            { path: "/growthCenter", name: "growthCenter", meta: { title: '成长中心' }, component: growthCenter },

            { path: "/collectionCenter", name: "collectionCenter", meta: { title: '收藏中心' }, component: collectionCenter },

            { path: "/myFollow", name: "myFollow", meta: { title: '我的关注' }, component: myFollow },

            { path: "/uesrManage", name: "uesrManage", meta: { title: '用户管理' }, component: uesrManage },
            { path: "/uesrAdd", name: "uesrAdd", meta: { title: '用户管理' }, component: uesrAdd },
            { path: "/uesrAiConfig", name: "userConfig", meta: { title: '用户权限配置管理' }, component: userConfig },

            { path: "/ptStatistics", name: "ptStatistics", meta: { title: '一体化教研统计', keepAlive: true }, component: ptStatistics },

            { path: "/jkyStatistics", name: "jkyStatistics", meta: { title: '教科研统计', keepAlive: true }, component: jkyStatistics },

            { path: "/msgzsStatistics", name: "msgzsStatistics", meta: { title: '名师工作室统计', keepAlive: true }, component: msgzsStatistics },

            { path: "/principalStudio", name: "principalStudio", meta: { title: '名校长工作室统计', keepAlive: true }, component: principalStudio },

            { path: '/fileFillsh', name: '档案审核', meta: { title: '档案审核', keepAlive: true }, component: fileFill },
            { path: '/fileAllocation', name: '档案分配', meta: { title: '档案分配', keepAlive: true }, component: fileAllocation },
            { path: '/fileManage', name: '档案管理', meta: { title: '档案管理', keepAlive: true }, component: fileManage },
            { path: '/checkList', name: '档案审核', meta: { title: '档案审核', keepAlive: true }, component: checkList },
            { path: '/setFileCheck', name: '设置档案审核员', meta: { title: '设置档案审核员', keepAlive: true }, component: setFileCheck },
            { path: '/fileList', name: '教师档案', meta: { title: '教师档案', keepAlive: true }, component: fileList },

            /*视频分析*/
            { path: "/courseAnalyse", name: "courseAnalyse", meta: { title: '教学分析', keepAlive: true }, component: courseAnalyse },
            { path: "/courseAnalyseCreate", name: "courseAnalyseCreate", meta: { title: '教学分析', keepAlive: true }, component: courseAnalyseCreate },
            { path: "/analyseReport", name: "analyseReport", meta: { title: '教学分析报告', keepAlive: true }, component: courseReportInfo },
            { path: "/analyseReportInfo", name: "analyseReportInfo", meta: { title: '教学分析报告', keepAlive: true }, component: courseAnalyseReportInfo },
            { path: "/analyseTaskCreate", name: "orgCourseAnalyseCreate", meta: { title: '新增教学分析', keepAlive: true }, component: orgCourseAnalyseCreate },


            { path: "/analyseAdmin", name: "analyseAdmin", meta: { title: '教学分析管理', keepAlive: true }, component: analyseAdmin },
            { path: "/analyseDetail", name: "analyseDetail", meta: { title: '教学分析详情', keepAlive: true }, component: analyseDetail },
            { path: "/teachAnalyse", name: "orgAnalyseDetail", meta: { title: '教学分析', keepAlive: true }, component: orgAnalyseDetail },


            /*统计*/
            { path: "/trainStat", name: "trainStat", meta: { title: '师资培训统计', keepAlive: true }, component: trainStat },
            { path: "/teachingStat", name: "teachingStat", meta: { title: '一体化教研统计', keepAlive: true }, component: teachingStat },

            /*人文美育*/
            { path: "/videoLibraryManage", name: "videoLibraryManage", meta: { title: '人文美育-视频库管理', keepAlive: true }, component: videoLibraryManage },
            { path: "/humanityCourseManager", name: "humanityCourseManager", meta: { title: '人文美育-课程管理', keepAlive: true }, component: humanityCourseManager },
            { path: "/humanityCourseCreate", name: "humanityCourseCreate", meta: { title: '人文美育-创建课程', keepAlive: true }, component: humanityCourseCreate },
            { path: "/humanityCourseDetail", name: "humanityCourseDetail", meta: { title: '人文美育-课程信息', keepAlive: true }, component: humanityCourseDetail },
            { path: "/humanityCourseInfo", name: "humanityCourseInfo", meta: { title: '人文美育-课程信息', keepAlive: true }, component: humanityCourseInfo },
            { path: "/humanityLibrary", name: "humanityLibraryManage", meta: { title: '人文美育-五馆合一', keepAlive: true }, component: humanityLibraryManage },
            { path: "/subjectFusion", name: "subjectFusionInfo", meta: { title: '人文美育-学科融合详情', keepAlive: true }, component: subjectFusionInfo },
            { path: "/museumCourse", name: "museumCourseList", meta: { title: '人文美育-五馆课程', keepAlive: true }, component: museumCourseList },
            { path: "/searchCourse", name: "searchCourseList", meta: { title: '人文美育-五馆课程', keepAlive: true }, component: searchCourseList },
            { path: "/searchHumanityVideo", name: "searchHumanityVideoList", meta: { title: '人文美育-五馆课程', keepAlive: true }, component: searchHumanityVideoList },

            /*美育浸润*/
            { path: "/myjr", name: "myjrIndex", meta: { title: '美育浸润', keepAlive: true }, component: myjrIndex },
            { path: "/myjrCreate", name: "myjrCreate", meta: { title: '美育浸润', keepAlive: true }, component: myjrCreate },
            { path: "/myjrDetail", name: "myjrDetail", meta: { title: '美育浸润', keepAlive: true }, component: myjrDetail },

            /*推荐书目*/
            { path: "/book", name: "bookIndex", meta: { title: '推荐书目', keepAlive: true }, component: bookIndex },
            { path: "/bookCreate", name: "bookCreate", meta: { title: '推荐书目', keepAlive: true }, component: bookCreate },
            { path: "/bookDetail", name: "bookDetail", meta: { title: '推荐书目', keepAlive: true }, component: bookDetail },

            /*主题活动*/
            { path: "/event", name: "eventIndex", meta: { title: '主题活动', keepAlive: true }, component: eventIndex },
            { path: "/eventCreate", name: "eventCreate", meta: { title: '主题活动', keepAlive: true }, component: eventCreate },
            { path: "/eventDetail", name: "eventDetail", meta: { title: '主题活动', keepAlive: true }, component: eventDetail },
            /*实践活动*/
            { path: "/practice", name: "practiceIndex", meta: { title: '实践活动', keepAlive: true }, component: practiceIndex },
            { path: "/practiceCreate", name: "practiceCreate", meta: { title: '实践活动', keepAlive: true }, component: practiceCreate},

            /*日清周结*/
            { path: "/rqzj", name: "rqzjIndex", meta: { title: '日清周结', keepAlive: true }, component: rqzjIndex},
            { path: "/rqzjManager", name: "rqzjManager", meta: { title: '日清周结管理', keepAlive: true }, component: rqzjManager},
            { path: "/rqzjView", name: "rqzjView", meta: { title: '日清周结查看文件', keepAlive: true }, component: rqzjView},

            /*三层量分定做*/
            { path: "/sclfdz", name: "sclfdzIndex", meta: { title: '三层量分定做', keepAlive: true }, component: sclfdzIndex},
            { path: "/sclfdzManager", name: "sclfdzManager", meta: { title: '三层量分定做管理', keepAlive: true }, component: sclfdzManager},
            { path: "/sclfdzView", name: "sclfdzView", meta: { title: '三层量分定做查看文件', keepAlive: true }, component: sclfdzView},

            /* 分层作业 */
            { path: "/homeworkManager", name: "homeworkManager", meta: { title: '分层作业管理', keepAlive: true }, component: homeworkManager},
            { path: "/homeworkView", name: "homeworkView", meta: { title: '分层作业详情', keepAlive: true }, component: homeworkView},

            /* 英语强化 */
            { path: "/englishImprove", name: "englishImporveIndex", meta: { title: '英语强化课程', keepAlive: true }, component: englishImporveIndex},
            { path: "/englishImproveCreate", name: "englishImproveCreate", meta: { title: '英语强化课程', keepAlive: true }, component: englishImproveCreate},
            { path: "/englishImproveVideo", name: "englishImproveUploadVideo", meta: { title: '英语强化课程', keepAlive: true }, component: englishImproveUploadVideo},
            { path: "/englishImproveDetail", name: "englishImproveCourseDetail", meta: { title: '英语强化课程', keepAlive: true }, component: englishImproveCourseDetail},
            { path: "/englishImproveView", name: "englishImproveViewCourse", meta: { title: '英语强化课程', keepAlive: true }, component: englishImproveViewCourse},

            /* 学霸讲专业 */
            { path: "/profession", name: "professionIndex", meta: { title: '学霸讲专业课程', keepAlive: true }, component: professionIndex},
            { path: "/professionCreate", name: "professionCreate", meta: { title: '学霸讲专业课程', keepAlive: true }, component: professionCreate},
            { path: "/professionVideo", name: "professionUploadVideo", meta: { title: '学霸讲专业课程', keepAlive: true }, component: professionUploadVideo},
            { path: "/professionDetail", name: "professionCourseDetail", meta: { title: '学霸讲专业课程', keepAlive: true }, component: professionCourseDetail},
            { path: "/professionView", name: "professionViewCourse", meta: { title: '学霸讲专业课程', keepAlive: true }, component: professionViewCourse},

            /* 圈考点 */
            { path: "/examPoint", name: "examPointManager", meta: { title: '圈考点', keepAlive: true }, component: examPointManager},
            { path: "/examPointView", name: "examPointView", meta: { title: '圈考点', keepAlive: true }, component: examPointView},

            /* 专业知晓 */
            { path: "/professionKnowledge", name: "professionKnowledgeManager", meta: { title: '专业知晓', keepAlive: true }, component: professionKnowledgeManager},
            { path: "/professionKnowledgeView", name: "professionKnowledgeView", meta: { title: '专业知晓', keepAlive: true }, component: professionKnowledgeView},

            /* 赢在规划 */
            { path: "/admission", name: "admissionManager", meta: { title: '赢在规划', keepAlive: true }, component: admissionManager},
            { path: "/admissionView", name: "admissionView", meta: { title: '赢在规划', keepAlive: true }, component: admissionView},

            /* 热搜题 */
            { path: "/hotQues", name: "hotQuesManager", meta: { title: '热搜题', keepAlive: true }, component: hotQuesManager},
            { path: "/hotQuesView", name: "hotQuesView", meta: { title: '热搜题', keepAlive: true }, component: hotQuesView},

            /* 学校文化中心-素材中心（学校文化） */
            { path: "/material", name: "materialManager", meta: { title: '学校文化-素材中心', keepAlive: true }, component: materialManager},
            { path: "/materialView", name: "materialView", meta: { title: '学校文化-素材中心', keepAlive: true }, component: materialView},
            { path: "/materialCDRView", name: "materialCDRView", meta: { title: '学校文化-素材中心', keepAlive: true }, component: materialCDRView},

        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.path.includes('app/')||
        to.path === '/hyedu/wel' ||
        to.path === '/hyedu/news' ||
        to.path === '/hyedu/evaStat' ||
        to.path === '/hyedu/officeLink' ||
        to.path === '/hyedu/flash' ||
        to.path === '/hyedu/jxssReport' ||
        to.path === '/hyedu/yxktReport' ||
        to.path === '/hyedu/archive' ||
        to.path === '/hyedu/paperQues' ||
        to.path === '/hyedu/paperCenter' ||
        to.path === '/login' ||
        to.path === '/codeLogin' ||
        to.path === '/resetPwd' ||
        to.path === '/workBook' ||
        to.path === '/register' ||
        to.path === '/oauth/authorize' ||
        to.path === '/editor' ||
        to.path === '/policy' ||
        to.path === '/inviteMember' ||
        to.path === '/expertJoin'||
        to.path === '/newsShare') return next()
    // 获取token
    const tokenStr = window.localStorage.getItem('token')
    if (!tokenStr) return next('/hyedu/wel')
    window.document.title = to.meta.title
    next()
})

export default router
